import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { SmsTemplateListOptionRequest } from '../models/sms-templates';
import { PatientSmsTemplateOption } from '../models/patients';

@Injectable({
  providedIn: 'root'
})
export class SmsTemplateDataService {
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getSmsTemplateOptionsAsync(query: string, clinicId: number, patientId: number, cancellationToken: Promise<any>): Promise<PatientSmsTemplateOption[]> {
    const request: SmsTemplateListOptionRequest = { searchString: query, clinicId, patientId };
    return this.httpClient.getJsonAsync<PatientSmsTemplateOption[]>('SmsTemplates/Options', request, cancellationToken);
  }

  public getSmsTemplateOptionsAllAsync(clinicId: number, patientId: number, cancellationToken: Promise<any>): Promise<PatientSmsTemplateOption[]> {
    const request = { clinicId, patientId };
    return this.httpClient.getJsonAsync<PatientSmsTemplateOption[]>('SmsTemplates/OptionsAll', request, cancellationToken);
  }
}
